import React from "react";
import TerminalNull from "./null";
import * as actions from "../../../actions";
import { connect } from "react-redux";

class TerminalMinify extends React.Component {
  componentDidMount() {
    const { minifyTerminal, uuid } = this.props;
    minifyTerminal(uuid);
  }

  render() {
    return <TerminalNull />;
  }
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  minifyTerminal: (payload) => {
    dispatch(actions.minifyTerminal(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TerminalMinify);
